export default "__VITE_ASSET__BbnGDYGk__"